/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_HarderInputs */

const en_us2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`harder`)
};

const pt_br2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais difícil`)
};

const es_419_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`más difícil`)
};

const pt_pt2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mais difícil`)
};

const fr_fr2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plus difficile`)
};

const de_de2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schwerer`)
};

const it_it2_swap_harder = /** @type {(inputs: Swap_HarderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`più difficile`)
};

/**
* | output |
* | --- |
* | "harder" |
*
* @param {Swap_HarderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_harder = /** @type {((inputs?: Swap_HarderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_HarderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_harder(inputs)
	if (locale === "es-419") return es_419_swap_harder(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_harder(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_harder(inputs)
	if (locale === "de-DE") return de_de2_swap_harder(inputs)
	if (locale === "it-IT") return it_it2_swap_harder(inputs)
	return en_us2_swap_harder(inputs)
});
export { swap_harder as "swap.harder" }